<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card>
      <v-toolbar dense class="">
        <v-toolbar-title>Enter PIN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card>
          <v-card-text>
              <v-text-field
                prepend-icon="security"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'"
                label=""
                v-model="passcode"
                :error-messages="passcodeErrors"
                counter
                @click:append="show1 = !show1" 
                @input="$v.passcode.$touch()"
                @blur="$v.passcode.$touch()"
                @keyup.enter="confirmPasscode"
              ></v-text-field>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="success" @click="confirmPasscode">Confirm</v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';

export default {
  name: 'AllReportsPasscodeModal',
  props: {
    value: Boolean
  },
  mixins: [validationMixin],
  data () {
    return {
      show1: false,
      passcode: '',
      validPasscode: 'k0be23'
    }
  },
  validations: {
    passcode: {
      required
    }
  },
  computed: {
    passcodeErrors() {
      const errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('PIN is required');
      return errors;
    }
  },
  methods: {
    confirmPasscode: function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Invalid PIN`,
          text: 'Make sure you filled the passcode correctly.'
        });
        return;
      }

      if (this.passcode === this.validPasscode) {
        this.$emit('success')
        this.closeModal()
      } else {
        this.$swal({
          type: 'error',
          title: `Invalid PIN`,
          text: 'Make sure you filled the PIN correctly.'
        });
      }
      return;
    },
    closeModal: function () {
      this.$v.$reset()
      this.$emit('input')
      this.passcode = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// AllReportsPasscodeModal.vue?6fb5243b